export default "__VITE_ASSET__Bs$IS1a8__"